import React, { Component } from 'react';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl, Radio, Checkbox, Button, ButtonToolbar } from 'react-bootstrap'

export class ExceptionsDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let exceptionsConfiguration = {
            displayType: "",
            showStopCode: false,
            stopCodePrecendentText: "",
            stopCodeSubsequentText: ""
        };

        if (null !== this.props.selectedData && undefined !== this.props.selectedData) {
            try {
                exceptionsConfiguration = Object.assign(exceptionsConfiguration, JSON.parse(this.props.selectedData));
            }
            catch(_) { }
        }

        this.state = {
            form: {
                displayType: exceptionsConfiguration.displayType,
                showStopCode: exceptionsConfiguration.showStopCode,
                stopCodePrecendentText: exceptionsConfiguration.stopCodePrecendentText,
                stopCodeSubsequentText: exceptionsConfiguration.stopCodeSubsequentText
            }
        };
    }

    onSelectData() {
        const { form } = this.state;

        const exceptionsConfiguration = {
            displayType: form.displayType,
            showStopCode: form.showStopCode,
            stopCodePrecendentText: form.stopCodePrecendentText,
            stopCodeSubsequentText: form.stopCodeSubsequentText
        };
        this.props.onSelectData(JSON.stringify(exceptionsConfiguration), true);
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    onChangeRadioValue(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    // -------------------------------

    renderStopTextConfigurationsForm(form) {
        return (
            <div>
                <FormGroup>
                    <ControlLabel className="margin-top-15">Confiração da Apresentação do Nome da Paragem</ControlLabel>
                    <Checkbox checked={form.showStopCode}
                        onChange={() => this.onChangeCheckboxValue("showStopCode")}>
                        Mostrar Código da Paragem
                    </Checkbox>
                </FormGroup>

                {this.renderStopCodePrecedentAndSubsequentTextForm(form)}
            </div>
        );
    }

    renderStopCodePrecedentAndSubsequentTextForm(form) {
        if(!form.showStopCode) {
            return null;
        }

        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Texto Precedente ao Código da Paragem</ControlLabel>
                <FormControl
                    type="text"
                    value={form.stopCodePrecendentText}
                    onChange={(e) => this.onChangeValue(e, "stopCodePrecendentText")} />

                <ControlLabel className="margin-top-15">Texto Subsequente ao Código da Paragem</ControlLabel>
                <FormControl
                    type="text"
                    value={form.stopCodeSubsequentText}
                    onChange={(e) => this.onChangeValue(e, "stopCodeSubsequentText")} />
            </FormGroup>
        );
    }

    render() {
        const { form } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <b>Como apresentar as Exceções</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Radio
                                    name="exceptionsFormat"
                                    checked={"PER_LINE" === form.displayType}
                                    onChange={() => this.onChangeRadioValue("PER_LINE", "displayType")} >
                                    Por Linha
                                </Radio>
                                <Radio
                                    name="exceptionsFormat"
                                    checked={"SPLIT_BY_SPACE" === form.displayType}
                                    onChange={() => this.onChangeRadioValue("SPLIT_BY_SPACE", "displayType")} >
                                    Separadas por um espaço - " "
                                </Radio>
                                <Radio
                                    name="exceptionsFormat"
                                    checked={"SPLIT_BY_PIPE" === form.displayType}
                                    onChange={() => this.onChangeRadioValue("SPLIT_BY_PIPE", "displayType")} >
                                    Separadas por uma barra - "|"
                                </Radio>
                            </FormGroup>

                            {this.renderStopTextConfigurationsForm(form)}
                        </Col>
                    </Row>
                </Grid>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onSelectData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/ExceptionsDataIdentifier.js